import { observable, set, action } from 'mobx';

export interface IUserPreferences {
  subscribed?: boolean;
  acceptedPrivacyPolicy?: boolean;
}

class UserPreferences {
  @observable subscribed = false;

  @observable acceptedPrivacyPolicy = false;

  @observable requirePrivacyPolicy = false;

  static fromJSON(data: IUserPreferences): UserPreferences {
    const userPreferences = new UserPreferences();
    set(userPreferences, data);

    return userPreferences;
  }

  @action
  setSubscribed(value: boolean): void {
    this.subscribed = value;
  }

  @action
  setAcceptedPrivacyPolicy(value: boolean): void {
    this.acceptedPrivacyPolicy = value;
  }

  @action
  setRequirePrivacyPolicy(value: boolean): void {
    this.requirePrivacyPolicy = value;
  }
}

export default UserPreferences;
